
import React from 'react';
import { FlowRender } from "../flow-render";
import {GreyBox} from "../../client/funcs/utils";
import { DwollaCustomerStates, DwollaFundingSourceStates } from "../dwolla/constants";
import {InitiateMicroPayments} from "../../client/payment/actions";
import {MX_STATE} from "../../client/payment/mx-connect";
import { OptionMenu } from "../prm/option-menu";
import { Text, dollarValidator } from "../prm/text";
import { RadioButton } from "../prm/radio-button";
import { Name } from "../prm/name";
import { price_string_to_dollars } from "../currency-utils";
import { render_funding_source_table } from "./widgets/dwolla-funding-source-table";
import { Spinner } from "../../client/funcs/utils";
import { DivGrid } from "../../client/components/div-grid";
import { AllNames } from "../onboarding-tda/shared-prms";
import { render_recurring_payment } from "./widgets/recurring-payment";
import { DEVICE_WIDTH, AccountState } from "../constants";
import {setCognitoAccountState} from "../../client/login/login/actions";
import { urlParamToObj } from "../url-util";
import { InfoDialog } from "../../client/helper/modals";
import {get_default_funding_source_id} from "../dwolla/utils";
import {config_to_url} from "../../client/helper/url";
import {CheckInstructions} from "./check-instructions";
import {WireInstructions} from "./wire-instructions";
import {sendCheckInstructions, sendWireInstructions} from "../../client/dashboard/user/actions";
import {logUserEvent} from "../../client/app/actions";
import {UserEvents} from "../user-events";
import {IAVFlow} from "../../client/payment/iav-flow";

const iav_label = "Instantly fund your account (for amounts less than $10,000)";
const ach_label = "Fund your account for any amount (needed for amounts greater than $10,000)";
const later_label = "Fund your account later, or by check";

const payment_method = new RadioButton(
  new Name("payment_method"),
  [
    new Name("instant_authorization", iav_label),
    new Name("ach", ach_label),
    new Name("later", later_label),
  ]
);

const MAX_IAV_AMT_USD = 50000;

const payment_choice = new RadioButton(
  new Name("payment_choice"),
  [
    new Name("fund_electronically", "Fund your account electronically"),
    new Name("fund_later", "Fund your account later"),
    new Name("fund_check", "Mail a check"),
    new Name("fund_wire", "Wire money (an email will be sent to you with instructions for your bank)"),
  ]
)
const payment_routing_number = new Text(
  new Name("payment_routing_number"));

const payment_account_number = new Text(
  new Name("payment_account_number"));

const payment_account_type = new OptionMenu(
  new Name("payment_account_type"),
  [
    new Name("checking", "Checking"),
    new Name("savings", "Savings"),
  ]
);

const payment_account_name = new Text(
  new Name("payment_account_name"));

const payment_source = new RadioButton(
  new Name("payment_source"));
payment_source.do_checkbox = true;

const invest_start_amt = new Text(
  new Name(AllNames.invest_start_amt,
    "Amount you would like to start investing with"));
invest_start_amt.setValidator(dollarValidator);

const contribute_yes_no = new RadioButton(
  new Name(AllNames.contribute_yes_no,
    "Do you want to contribute on a regular basis?"),
  [
    new Name("yes", "Yes"),
    new Name("no", "No"),
  ]
);

const contribute_cadence = new OptionMenu(
  new Name(AllNames.contribute_cadence, "How often"),
  [
    new Name("monthly", "Monthly"),
    new Name("quarterly", "Quarterly"),
    new Name("annually", "Annually"),
  ]
);

const contribute_amt = new Text(
  new Name(AllNames.contribute_amt, "How much"));
contribute_amt.setValidator(dollarValidator);


const array_eq = (ids, buttonList) => {
  if (ids.length !== buttonList.length) {
    return false;
  }
  for(let i=0; i < ids.length; i++) {
    if (ids[i] !== buttonList[i].id) {
      return false;
    }
  }
  return true;
};

const EMAIL = {
  wire: "wire",
  check: "check",
}

class PaymentSource extends FlowRender {

  constructor(fund_later=true) {
    super(null, [
      payment_method,
      payment_routing_number,
      payment_account_number,
      payment_account_name,
      payment_account_type,
      payment_source,
      invest_start_amt,
      contribute_yes_no,
      contribute_cadence,
      contribute_amt,
      payment_choice,
    ]);
    this.fund_later = fund_later;
    invest_start_amt.onChangeCallback = this.onChange;
    contribute_yes_no.onChangeCallback = this.onChange;
    contribute_cadence.onChangeCallback = this.onChange;
    contribute_amt.onChangeCallback = this.onChange;

    payment_routing_number.onChangeCallback = this.onChange;
    payment_account_number.onChangeCallback = this.onChange;
    payment_account_name.onChangeCallback = this.onChange;
    this.url = "payment_source";
  }

  init(componentState, appState, component) {
    super.init(componentState, appState, component);
    componentState.mx_flow = MX_STATE.INIT;
    componentState.loading = false;
    componentState.adding_payment_source = false;
    componentState.micropay_enable = false;
    componentState.micropay_verify_enable = false;
    componentState.error = "";
    componentState.sending_email = false;
  }

  onChange = (component, newState) => {
    const rout_filled = !payment_routing_number.isBlank(newState);
    const acct_filled = !payment_account_number.isBlank(newState);
    const name_filled = !payment_account_name.isBlank(newState);
    newState.micropay_enable = rout_filled && acct_filled && name_filled;

  };

  onNewProps(component, state, props) {
    const dwolla = props.dwolla["0000"];
    const onboarding = component.getOnboardingData(props);
    const ids = Object.keys(dwolla.funding_source);
    if (!array_eq(ids, payment_source.buttonList)) {
      payment_source.setButtonList(ids.map(id => new Name(id)));
      payment_source.initState(state);
      payment_source.loadFromState(onboarding, state);
    }
  }

  onMount(component) {

    const args = urlParamToObj(component.getPathQuery());
    if (args.event === "cancel" || args.event === "decline") {
      logUserEvent(__filename, UserEvents.DOCUSIGN_NOT_COMPLETED, {
        username: component.props.user.username,
        index: component.getOnboardingIndex(),
        event: args.event,
      }).then();
      component.props.navigatePath(component.getRootUrl() + "/summary");
      return;
    }
    if (args.event === "signing_complete") {
      component.writeEnvelopeSigned();
    }

    const account_state = component.getAccountState();
    if (account_state === AccountState.ONBOARDING) {
      setCognitoAccountState(
        component.props.token,
        component.props.onboarding_token,
        AccountState.SIGNED,
        component.getOnboardingIndex())
        .then(result => {
          if (result.success) {
            component.props.setAccountState(
              AccountState.SIGNED, component.getOnboardingIndex());
          }
        })
    }

    const dwolla = component.getDwollaData(0);
    const source_id = get_default_funding_source_id(dwolla);
    if (source_id) {
      const url = component.getRootUrl() + "/payment?" + source_id;
      component.props.navigatePath(url);
    }

  }

  canNavigateNext(component) {
    const pay_choice = payment_choice.getValue(component.state, true);
    if (
      pay_choice === "fund_later" || pay_choice === "fund_check" || pay_choice === "fund_wire") {
      return component.getRootUrl() + "/signing_done";
    }

    return null;
  }

  renderNotVerified = () => {
    const text = "Customer not verified. Check with Advisor.";
    return (
      <div style={{ fontSize: "1.5rem"}}>
        {text}
      </div>
    )
  };

  onInitiateMicro = component => () => {
    component.setState({ loading: true, error: "" }, () => {
      component.saveParameters()
        .then(() => {
          InitiateMicroPayments(
            component.props.token, component.props.onboarding_token,
            payment_routing_number.getValue(component.state),
            payment_account_number.getValue(component.state),
            payment_account_type.getValue(component.state).id,
            payment_account_name.getValue(component.state))
            .then(result => {
              if (result.success) {
                component.props.dwollaUpdate(result.dwolla, 0);
                const source_id = result.funding_source_id;
                const url = component.getRootUrl() + "/signing_done?microdeposit_initiated=" + source_id;
                component.onNavigate(url);
                component.setState({ loading: false });
              } else {
                console.log("Error", result);
                component.setState({ loading: false, error: result.message })
              }
            })
        });
    });

  };


  renderACH = component => {
    const micro_disable = !component.state.micropay_enable || component.state.loading;
    const button_text = component.state.loading
      ? (<span style={{fontSize: "1rem", fontWeight: "bold"}}><Spinner/></span>)
      : (<span>{"Begin Verification"}</span>);
    const input_style = {
      marginBottom: "2rem",
      width: "15rem",
      textAlign: "center",
    };

    const fullWidth = "100%";
    const halfWidth = "50%"; 
    const responsiveWidthBreakpoint = component.props.app.width <= DEVICE_WIDTH.large  ? fullWidth : halfWidth;

    const div_style = {
        display: "inline-block",
        width: `${responsiveWidthBreakpoint}`,
        padding: "1rem",
    }
    const additionalStyle = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    }
    const text_0 = "To verify your account we will send 2 very small payments (amounts like "
      + "$0.24 and $0.71 for example). When you enter these unique amounts, we’ll know it’s your account.";
    const text_1 = "We value sound security as much as sound investing.";

    const rows = [
      {
        width: 0,
        elem: (
          <div align={"left"} style={{flex: "1 1 auto"}}>
            <div style={{fontSize: "1.5rem"}}>Bank Information</div>
            <GreyBox style={additionalStyle}>
              { payment_routing_number.renderInputDiv(component, null, "Routing Number") }
              <div style={{height: "0.5rem"}}/>
              { payment_account_number.renderInputDiv(component, null, "Account Number") }
              <div style={{height: "0.5rem"}}/>
              { payment_account_name.renderInputDiv(component, null, "Account Name") }
              <div style={{height: "0.5rem"}}/>
              { payment_account_type.renderMenuDiv(component, { width: "100%"}, "Account Type") }
            </GreyBox>
          </div>
        ),
        div_style: div_style,
      },
      {
        width: 0,
        elem: (
          <div>
            <div style={{height: "5rem"}} />
            <div>{invest_start_amt.name.label}</div>
            { invest_start_amt.renderInput(component, input_style) }
            <div>{contribute_yes_no.name.label}</div>
            { render_recurring_payment(
              component, contribute_yes_no, contribute_amt, contribute_cadence) }
          </div>
        ),
        div_style: div_style,
      },
    ];

    const error = component.state.error;
    const has_error = !!error;

    return (
      <div>
        <div>
          <p>{text_0}</p>
          <div style={{height: "1rem"}}/>
          <p>{text_1}</p>
        </div>
        <DivGrid className="divgrid-container-responsive" items={[rows]}/>
        <div align={"center"} style={{marginTop: "2rem"}} >
          { this.renderActionButton(button_text, this.onInitiateMicro(component), micro_disable) }
          <div style={{height: "1rem"}}/>
          { has_error && <div style={{ fontSize: "1.5rem"}}>{error}</div> }
        </div>
      </div>
    );
  };

  onSourceCB = (component) => () => {
    const id = payment_source.getValue(component.state, true);
    const url = component.getRootUrl() + "/payment?" + id;
    component.onNavigate(url);
  };

  on_iav_state = component => mx_flow => {
    component.setState({ mx_flow });
  }

  on_iav_done = component => payment_id => {
    if (payment_id) {
      const url = component.getRootUrl() + "/payment?" + payment_id;
      component.props.navigatePath(url);
    }
  }

  renderExistingSources = component => {
    const text = "Use an existing payment source.";
    const dwolla = component.getDwollaData(0);

    const payment_ids = Object.keys(dwolla.funding_source).filter(id => {
      return dwolla.funding_source[id].state === DwollaFundingSourceStates.VERIFIED;
    });

    const empty = payment_ids.length === 0;

    if (empty) {
      return null;
    }

    const buttons_clicked = payment_source.isClicked(component.state);
    return (
      <div>
        <div style={{ fontSize: "1.5rem"}}>{text}</div>
        <div style={{height: "0.5rem"}} />
        { empty && <span>-- EMPTY--</span>}
        { !empty && render_funding_source_table(component, dwolla, payment_ids, payment_source) }
        { !empty && this.renderActionButton(
          "Use this Account", this.onSourceCB(component), !buttons_clicked) }
        <div style={{height: "2rem"}}/>
        <hr style={{backgroundColor: "black" }} />
      </div>
    )
  };

  renderIAVDone = component => {
    const id = component.state.payment_source_id;
    const dwolla = component.getDwollaData(0);

    if (!id) {
      return (<Spinner/>);
    }

    return (
      <div>
        { render_funding_source_table(component, dwolla, [id])}
        <div style={{height: "2rem"}} />
        <div>
          { this.renderNextButton(component) }
        </div>
      </div>
    );
  }

  renderIAVError = component => {
    const on_close = () => () => {
      component.setState({
        mx_flow: MX_STATE.INIT,
      })
    };

    return (
      <div>
        <InfoDialog onClick={on_close}>
          <span>There was an error adding your bank.</span>
        </InfoDialog>
      </div>
    )
  }

  emailDetails = (component, email_type) => () => {
    component.setState({
      sending_email: true,
    })
    if (email_type === EMAIL.wire) {
      sendWireInstructions(
        component.props.token,
        component.props.onboarding_token,
        component.props.user.username,
        component.getOnboardingIndex()).then(() => {
        component.setState({
          sending_email: false,
        })
      });
    } else if (email_type === EMAIL.check) {
      sendCheckInstructions(
        component.props.token,
        component.props.onboarding_token,
        component.props.user.username,
        component.getOnboardingIndex()).then(() => {
        component.setState({
          sending_email: false,
        })
      });
    }

  }

  maybeRenderPaymentSource = component => {
    const dwolla = component.getDwollaData(0);

    if (dwolla.customer.state !== DwollaCustomerStates.VERIFIED) {
      return null;
    }

    const onboarding = component.getOnboardingData();
    const method = payment_choice.getValue(component.state, true);

    const label_style = {
      fontSize: "1.2rem",
    };
    const renderButton = (component, index) => {
      return (
        <div align={"left"} style={{display: "flex", alignItems: "center", paddingBottom: "1rem"}}>
          <div style={{display: "inline-block", verticalAlign: "top"}}>
            { payment_choice.renderCheckbox(index, component) }
          </div>
          <div style={{display: "inline-block"}}>
            { payment_choice.renderLabel(index, component.state, label_style) }
          </div>
        </div>
      );
    };

    let bottom, instructons;
    if (method === "fund_later" || method === "fund_check" || method === "fund_wire") {
      if (method === "fund_check") {
        instructons = (
          <CheckInstructions
            sending_email={component.state.sending_email}
            custodian={component.props.wlf.custodian}
            acct_num={component.getTDAData().account_number}
            acct_type={component.getTDAData().account_type}
            on_click={this.emailDetails(component, EMAIL.check)}
            onboarding={component.getOnboardingData()}
        />);
      } else if (method === "fund_wire") {
        const onboarding = component.getOnboardingData();
        const name = onboarding.role_0_first_name + " " + onboarding.role_0_last_name;
        instructons = (
          <WireInstructions
            custodian={component.props.wlf.custodian}
            acct_num={component.getTDAData().account_number}
            name={name}
            sending_email={component.state.sending_email}
            on_click={this.emailDetails(component, EMAIL.wire)}
            />);
      }
      bottom = (
        <div style={{marginTop: "2rem"}}>
          { this.renderNextButton(component) }
        </div>
      );
    } else if (method === "fund_electronically") {
      const initial_amt = price_string_to_dollars(onboarding.invest_start_amt);
      if (initial_amt <= MAX_IAV_AMT_USD) {
        const ping_url = config_to_url(component.props.config);
        const url = ping_url + component.getRootUrl() + "/payment_source";
        bottom = (
          <IAVFlow
            url={url}
            on_iav_done={this.on_iav_done(component)}
            on_iav_state={this.on_iav_state(component)}
            component={component}
            state={component.state}
            button_text={"Instantly Fund Your Account"}/>);
      }
    }

    return (
      <div>
        <div style={{height: "1rem"}}/>
        { this.renderExistingSources(component) }
        <div style={{height: "1rem"}}/>
        { /* MxConnect Widget */ }
        { renderButton(component, 0) }
        { this.fund_later && renderButton(component, 1) }
        { renderButton(component, 2) }
        { renderButton(component, 3) }
        <div style={{height: "1rem"}}/>
        { instructons }
        { bottom }
      </div>
    );
  }

  renderBody = component => {
    const dwolla = component.getDwollaData(0);
    const is_verified = dwolla.customer.state === DwollaCustomerStates.VERIFIED;
    const adding_payment_source = component.state.mx_flow === MX_STATE.ADDING_PAYMENT_SOURCE
      ? (
        <div align={"center"}>
          <div>Adding payment source</div>
          <div style={{height: "1rem"}}/>
          <div>
            <Spinner size={"2rem"}/>
          </div>
        </div>
      ) : null;

    const error = component.state.mx_flow === MX_STATE.ERROR;

    return (
      <div>
        <div align={"center"}>
          { this.renderTitle(component, "Fund your account", "100%") }
          { !is_verified && this.renderNotVerified(component) }
          { is_verified && !adding_payment_source && this.maybeRenderPaymentSource(component) }
          { adding_payment_source }
          { error && this.renderIAVError(component) }
        </div>
      </div>
    )
  };

  render = component => {
    const onboarding = component.getOnboardingData();
    const initial_amt = price_string_to_dollars(onboarding.invest_start_amt);
    const pay_electronic = payment_choice.getValue(component.state, true) === 'fund_electronically';
    const show_ach = initial_amt > MAX_IAV_AMT_USD && pay_electronic;

    const halfWidth = "50%";
    const threeQuarterWidth = "75%";
    const responsiveWidthBreakpoint = component.props.app.width <= DEVICE_WIDTH.ultra_large  ? threeQuarterWidth : halfWidth;

    return (
      <div>
        { this.renderSingleColumn(this.renderBody(component)) }
        { show_ach && this.renderSingleColumn(this.renderACH(component), responsiveWidthBreakpoint) }
      </div>
    );
  }
}

export { PaymentSource };
